import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from 'react';
const DEFAULT_POSITION = {};

// This hook is used to get the user's current location (as latitude and
// longitude) using the browser's geolocation API. Requesting the location
// requires the user's permission, so this hook is disabled by default, and
// must be enabled by passing true as the first argument.
const useBrowserGeolocation = (t0, t1) => {
  const $ = _c(14);
  const enabled = t0 === undefined ? false : t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const {
    enableHighAccuracy: t3,
    maximumAge: t4,
    timeout: t5
  } = options;
  const enableHighAccuracy = t3 === undefined ? true : t3;
  const maximumAge = t4 === undefined ? 60000 : t4;
  const timeout = t5 === undefined ? 5000 : t5;
  const [position, setPosition] = useState(DEFAULT_POSITION);
  const [error, setError] = useState(null);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = t7 => {
      const {
        coords,
        timestamp
      } = t7;
      setPosition({
        accuracy: coords.accuracy,
        heading: coords.heading,
        latitude: coords.latitude,
        longitude: coords.longitude,
        speed: coords.speed,
        timestamp
      });
      setError(null);
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const onChange = t6;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = updatedError => {
      setError(updatedError?.message);
    };
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const onError = t7;
  let t8;
  let t9;
  if ($[4] !== enableHighAccuracy || $[5] !== enabled || $[6] !== maximumAge || $[7] !== timeout) {
    t8 = () => {
      if (!enabled) {
        return;
      }
      if (!navigator || !navigator.geolocation) {
        setError("Geolocation is not supported");
        return;
      }
      navigator.geolocation.getCurrentPosition(onChange, onError, {
        enableHighAccuracy,
        timeout,
        maximumAge
      });
    };
    t9 = [enabled, enableHighAccuracy, maximumAge, onChange, onError, timeout];
    $[4] = enableHighAccuracy;
    $[5] = enabled;
    $[6] = maximumAge;
    $[7] = timeout;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  useEffect(t8, t9);
  const t10 = enabled && !position?.latitude;
  let t11;
  if ($[10] !== error || $[11] !== position || $[12] !== t10) {
    t11 = {
      ...position,
      error,
      isLoading: t10
    };
    $[10] = error;
    $[11] = position;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};
export default useBrowserGeolocation;